export default class Dimens {
    public static readonly APP_LOGO_TEXT_SIZE = "1rem";
    public static readonly APP_BAR_HEIGHT = "5rem";
    public static readonly MAX_WIDTH=4096;
}